var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_202_5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0342 13.4657C9.72183 13.1534 9.72183 12.6468 10.0342 12.3344L12.2969 10.0716C12.6093 9.75927 13.1159 9.75927 13.4283 10.0716C13.7407 10.384 13.7407 10.8906 13.4283 11.203L11.1656 13.4657C10.8532 13.7781 10.3466 13.7781 10.0342 13.4657Z",
    fill: "url(#paint0_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2969 11.203C11.9845 10.8906 11.9845 10.384 12.2969 10.0716C12.6093 9.75927 13.1159 9.75927 13.4283 10.0716C13.7406 10.384 13.7406 10.8906 13.4283 11.203C13.1159 11.5154 12.6093 11.5154 12.2969 11.203Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0342 12.3343C10.3466 12.022 10.8532 12.022 11.1656 12.3343L13.4283 14.5971C13.7407 14.9095 13.7407 15.4161 13.4283 15.7284C13.1159 16.0408 12.6093 16.0408 12.2969 15.7284L10.0342 13.4657C9.72183 13.1533 9.72183 12.6467 10.0342 12.3343Z",
    fill: "url(#paint1_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.2969 14.5971C12.6093 14.2847 13.1159 14.2847 13.4283 14.5971C13.7406 14.9095 13.7406 15.4161 13.4283 15.7285C13.1159 16.0408 12.6093 16.0408 12.2969 15.7285C11.9845 15.4161 11.9845 14.9095 12.2969 14.5971Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.1655 12.3343C11.4779 12.6467 11.4779 13.1533 11.1655 13.4657L8.90276 15.7284C8.59038 16.0408 8.08377 16.0408 7.77139 15.7284C7.45902 15.4161 7.45902 14.9095 7.77139 14.5971L10.0341 12.3343C10.3465 12.022 10.8531 12.022 11.1655 12.3343Z",
    fill: "url(#paint2_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.90276 14.5971C9.21514 14.9095 9.21514 15.4161 8.90276 15.7285C8.59038 16.0408 8.08377 16.0408 7.77139 15.7285C7.45902 15.4161 7.45902 14.9095 7.77139 14.5971C8.08377 14.2847 8.59038 14.2847 8.90276 14.5971Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.1655 13.4657C10.8531 13.7781 10.3465 13.7781 10.0341 13.4657L7.77139 11.203C7.45902 10.8906 7.45902 10.384 7.77139 10.0716C8.08377 9.75927 8.59038 9.75927 8.90276 10.0716L11.1655 12.3344C11.4779 12.6468 11.4779 13.1534 11.1655 13.4657Z",
    fill: "url(#paint3_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.90276 11.203C8.59038 11.5154 8.08377 11.5154 7.77139 11.203C7.45902 10.8906 7.45902 10.384 7.77139 10.0716C8.08377 9.75927 8.59038 9.75927 8.90276 10.0716C9.21514 10.384 9.21514 10.8906 8.90276 11.203Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.79944 12.9C9.79944 12.4583 10.1576 12.1002 10.5993 12.1002H15.3993C15.841 12.1002 16.1992 12.4583 16.1992 12.9C16.1992 13.3417 15.841 13.6998 15.3993 13.6998H10.5993C10.1576 13.6998 9.79944 13.3417 9.79944 12.9Z",
    fill: "url(#paint4_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.6001 12.9C14.6001 12.4583 14.9582 12.1002 15.3999 12.1002C15.8416 12.1002 16.1998 12.4583 16.1998 12.9C16.1998 13.3417 15.8416 13.6999 15.3999 13.6999C14.9582 13.6999 14.6001 13.3417 14.6001 12.9Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M10.5998 12.1002C11.0415 12.1002 11.3996 12.4583 11.3996 12.9V17.7001C11.3996 18.1418 11.0415 18.4999 10.5998 18.4999C10.1581 18.4999 9.79993 18.1418 9.79993 17.7001V12.9C9.79993 12.4583 10.1581 12.1002 10.5998 12.1002Z",
    fill: "url(#paint5_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M10.5998 16.9002C11.0415 16.9002 11.3996 17.2584 11.3996 17.7001C11.3996 18.1418 11.0415 18.4999 10.5998 18.4999C10.1581 18.4999 9.79993 18.1418 9.79993 17.7001C9.79993 17.2584 10.1581 16.9002 10.5998 16.9002Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.3997 12.9C11.3997 13.3417 11.0416 13.6998 10.5999 13.6998H5.79983C5.35814 13.6998 5 13.3417 5 12.9C5 12.4583 5.35814 12.1002 5.79983 12.1002H10.5999C11.0416 12.1002 11.3997 12.4583 11.3997 12.9Z",
    fill: "url(#paint6_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M6.59967 12.9C6.59967 13.3417 6.24153 13.6998 5.79983 13.6998C5.35814 13.6998 5 13.3417 5 12.9C5 12.4583 5.35814 12.1002 5.79983 12.1002C6.24153 12.1002 6.59967 12.4583 6.59967 12.9Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M10.5998 13.6999C10.1581 13.6999 9.79993 13.3417 9.79993 12.9V8.09997C9.79993 7.65827 10.1581 7.30013 10.5998 7.30013C11.0415 7.30013 11.3996 7.65827 11.3996 8.09997V12.9C11.3996 13.3417 11.0415 13.6999 10.5998 13.6999Z",
    fill: "url(#paint7_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M10.5998 8.8998C10.1581 8.8998 9.79993 8.54166 9.79993 8.09997C9.79993 7.65827 10.1581 7.30013 10.5998 7.30013C11.0415 7.30013 11.3996 7.65827 11.3996 8.09997C11.3996 8.54166 11.0415 8.8998 10.5998 8.8998Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.5998 2.1003C13.0415 2.1003 13.3996 2.45845 13.3996 2.90014V4.50034C13.3996 4.94203 13.0415 5.30017 12.5998 5.30017C12.1581 5.30017 11.7999 4.94203 11.7999 4.50034V2.90014C11.7999 2.45845 12.1581 2.1003 12.5998 2.1003Z",
    fill: "url(#paint8_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M12.5998 3.69991C13.0415 3.69991 13.3996 4.05806 13.3996 4.49975C13.3996 4.94144 13.0415 5.29958 12.5998 5.29958C12.1581 5.29958 11.7999 4.94144 11.7999 4.49975C11.7999 4.05806 12.1581 3.69991 12.5998 3.69991Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M13.4002 2.90014C13.4002 3.34183 13.042 3.69997 12.6003 3.69997H11.0002C10.5585 3.69997 10.2003 3.34183 10.2003 2.90014C10.2003 2.45845 10.5585 2.1003 11.0002 2.1003H12.6003C13.042 2.1003 13.4002 2.45845 13.4002 2.90014Z",
    fill: "url(#paint9_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11.8 2.90014C11.8 3.34183 11.4418 3.69997 11.0002 3.69997C10.5585 3.69997 10.2003 3.34183 10.2003 2.90014C10.2003 2.45845 10.5585 2.1003 11.0002 2.1003C11.4418 2.1003 11.8 2.45845 11.8 2.90014Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M12.5998 3.69995C12.1581 3.69995 11.7999 3.34181 11.7999 2.90012V1.29992C11.7999 0.858226 12.1581 0.500084 12.5998 0.500084C13.0415 0.500084 13.3996 0.858226 13.3996 1.29992V2.90012C13.3996 3.34181 13.0415 3.69995 12.5998 3.69995Z",
    fill: "url(#paint10_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M12.5998 2.10044C12.1581 2.10044 11.7999 1.7423 11.7999 1.30061C11.7999 0.85892 12.1581 0.500778 12.5998 0.500778C13.0415 0.500778 13.3996 0.85892 13.3996 1.30061C13.3996 1.7423 13.0415 2.10044 12.5998 2.10044Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M11.7999 2.90014C11.7999 2.45845 12.1581 2.1003 12.5998 2.1003H14.2C14.6416 2.1003 14.9998 2.45845 14.9998 2.90014C14.9998 3.34183 14.6416 3.69997 14.2 3.69997H12.5998C12.1581 3.69997 11.7999 3.34183 11.7999 2.90014Z",
    fill: "url(#paint11_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M13.4001 2.90014C13.4001 2.45845 13.7583 2.1003 14.2 2.1003C14.6417 2.1003 14.9998 2.45845 14.9998 2.90014C14.9998 3.34183 14.6417 3.69997 14.2 3.69997C13.7583 3.69997 13.4001 3.34183 13.4001 2.90014Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M3.19983 5.30016C3.19983 4.85847 3.55797 4.50033 3.99966 4.50033H7.20006C7.64175 4.50033 7.99989 4.85847 7.99989 5.30016C7.99989 5.74185 7.64175 6.09999 7.20006 6.09999H3.99966C3.55797 6.09999 3.19983 5.74185 3.19983 5.30016Z",
    fill: "url(#paint12_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M6.39966 5.30012C6.39966 4.85842 6.7578 4.50028 7.19949 4.50028C7.64118 4.50028 7.99933 4.85842 7.99933 5.30012C7.99933 5.74181 7.64118 6.09995 7.19949 6.09995C6.7578 6.09995 6.39966 5.74181 6.39966 5.30012Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M3.99966 4.50033C4.44135 4.50033 4.7995 4.85847 4.7995 5.30016V8.50056C4.7995 8.94225 4.44135 9.30039 3.99966 9.30039C3.55797 9.30039 3.19983 8.94225 3.19983 8.50056V5.30016C3.19983 4.85847 3.55797 4.50033 3.99966 4.50033Z",
    fill: "url(#paint13_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M3.99966 7.70021C4.44135 7.70021 4.7995 8.05835 4.7995 8.50004C4.7995 8.94173 4.44135 9.29988 3.99966 9.29988C3.55797 9.29988 3.19983 8.94173 3.19983 8.50004C3.19983 8.05835 3.55797 7.70021 3.99966 7.70021Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M4.80006 5.30016C4.80006 5.74185 4.44192 6.09999 4.00023 6.09999H0.799833C0.358142 6.09999 0 5.74185 0 5.30016C0 4.85847 0.358142 4.50033 0.799833 4.50033H4.00023C4.44192 4.50033 4.80006 4.85847 4.80006 5.30016Z",
    fill: "url(#paint14_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M1.59967 5.30016C1.59967 5.74185 1.24152 6.09999 0.799833 6.09999C0.358142 6.09999 0 5.74185 0 5.30016C0 4.85847 0.358142 4.50033 0.799833 4.50033C1.24152 4.50033 1.59967 4.85847 1.59967 5.30016Z",
    fill: "#0098FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M3.99966 6.09995C3.55797 6.09995 3.19983 5.74181 3.19983 5.30012V2.09972C3.19983 1.65803 3.55797 1.29989 3.99966 1.29989C4.44135 1.29989 4.7995 1.65803 4.7995 2.09972V5.30012C4.7995 5.74181 4.44135 6.09995 3.99966 6.09995Z",
    fill: "url(#paint15_linear_202_5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M3.99966 2.90024C3.55797 2.90024 3.19983 2.5421 3.19983 2.10041C3.19983 1.65872 3.55797 1.30058 3.99966 1.30058C4.44135 1.30058 4.7995 1.65872 4.7995 2.10041C4.7995 2.5421 4.44135 2.90024 3.99966 2.90024Z",
    fill: "#0098FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_5",
    x1: 10.0343,
    y1: 13.4654,
    x2: 13.4285,
    y2: 10.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_5",
    x1: 10.034,
    y1: 12.3339,
    x2: 13.4285,
    y2: 15.7284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_202_5",
    x1: 11.1655,
    y1: 12.3343,
    x2: 7.7713,
    y2: 15.7285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_202_5",
    x1: 11.1654,
    y1: 13.4655,
    x2: 7.77126,
    y2: 10.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_202_5",
    x1: 9.79944,
    y1: 12.9,
    x2: 16.2002,
    y2: 12.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_202_5",
    x1: 10.5998,
    y1: 12.1002,
    x2: 10.5998,
    y2: 18.5004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_202_5",
    x1: 11.3997,
    y1: 12.9,
    x2: 4.99947,
    y2: 12.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_202_5",
    x1: 10.5998,
    y1: 13.6999,
    x2: 10.5998,
    y2: 7.2996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_202_5",
    x1: 12.5998,
    y1: 2.1003,
    x2: 12.5998,
    y2: 5.30017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_202_5",
    x1: 13.4002,
    y1: 2.90014,
    x2: 10.1998,
    y2: 2.90014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_202_5",
    x1: 12.5998,
    y1: 3.69995,
    x2: 12.5998,
    y2: 0.500084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_202_5",
    x1: 11.7999,
    y1: 2.90014,
    x2: 14.9998,
    y2: 2.90014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_202_5",
    x1: 3.19983,
    y1: 5.30016,
    x2: 7.99989,
    y2: 5.30016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_202_5",
    x1: 3.99966,
    y1: 4.50033,
    x2: 3.99966,
    y2: 9.30039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_202_5",
    x1: 4.80006,
    y1: 5.30016,
    x2: -0.000532216,
    y2: 5.30016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_202_5",
    x1: 3.99966,
    y1: 6.09995,
    x2: 3.99966,
    y2: 1.29989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F2ECE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0098FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form-icon.4c4f3ea8d9c8e748a9fbf9553e020583.svg";
export { ForwardRef as ReactComponent };